import { getCompanyData } from 'store/slices/company';
import { getUserConfig } from 'store/slices/userConfig';
import { getCompanyPlatformsFromCompany } from 'store/slices/companyPlatforms';
import { getWhatsappTemplates } from 'store/slices/templates';
import { getCompanyLabelsList } from 'store/slices/labels';
import { loadContactTags } from 'store/slices/contactTags';
import { getApplicationUsers } from 'store/slices/applicationUsers';
import { getUnreadChatUsers } from 'store/slices/unread-chat-users';
import { getUnreadCounts } from 'store/slices/status-unread-counts';
import { getPriorityDocTypes } from 'store/slices/priority';
import { getMassMessagingGroups, getMassMessagingTasks } from 'store/slices/mass-messaging';
import { getSimpleTemplates } from 'store/slices/simple-templates';
import { store } from 'store';
import { noteResync } from 'utils/socket-health-monitor';
import { fetchAccountModules } from 'utils/fetchAccountModules';

export const getDataOnLoad = async () => {
  console.log('[DEBUG-REFRESH] getDataOnLoad called', new Date().toISOString(), new Error().stack);
  noteResync('getDataOnLoad');
  const getCompany = async () => {
    await getCompanyData();
    getCompanyPlatformsFromCompany();

    if (store.getState().company?.CompanyType === 'priority') {
      getPriorityDocTypes();
    }

    void fetchAccountModules();
  };
  getCompany();
  getUserConfig();
  getWhatsappTemplates();
  getSimpleTemplates(); // Load simple templates on app initialization
  getCompanyLabelsList();
  loadContactTags();
  getApplicationUsers();
  getUnreadChatUsers();
  getUnreadCounts();
  getMassMessagingGroups();
  getMassMessagingTasks();
};
